// the UI just handles stats being null and hiding it so just
// using a stub in here to override.
export const useDemoQuizStats = (lessonId, questionId = null) => {
  return {
    data: null,
    isLoading: false,
    error: false,
  };
};
